import { closeAside, openAside } from '@newStore/documentUI/documentUIState';

export const initRouter = ($stateProvider, $urlRouterProvider, $locationProvider) => {
  // Redirects

  $locationProvider.html5Mode(true);
  $urlRouterProvider.when('', '/documents');
  $urlRouterProvider.when('/', '/documents');

  // 404 if state not found
  $urlRouterProvider.otherwise(($injector) => {
    $injector.get('$state').go('notFound', null, { location: false });
  });

  // Default pages
  $stateProvider.state('notFound', {
    url: '/404',
    template: require('../screen/notFound/notFound.html'),
  });

  // Edit

  $stateProvider
    .state('list', {
      url: '/documents',
      component: 'listScreen',
    })
    .state('edit', {
      url: '/edit/:key',
      component: 'structureScreen',
    })
    .state('edit.aside', {
      url: '/:editKey',
      template: '',
      controller: [
        '$scope',
        '$aside',
        '$ngRedux',
        '$stateParams', // Add $stateParams here
        ($scope, $aside, $ngRedux, $stateParams) => {
          const editingNode = `/content/${$stateParams.editKey}`;
          if ($ngRedux.getState().documentUI.currentEditingNode !== editingNode) {
            $ngRedux.dispatch(openAside({ href: editingNode }));
          }
          $scope.$on('$destroy', () => {
            if ($ngRedux.getState().documentUI.currentEditingNode !== null) {
              $ngRedux.dispatch(closeAside());
            }
          });
        },
      ],
    });
};
